import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {Job} from '@cp/model';
import {CREATE_SEED_QUESTION_VARIANT_JOB} from '../sharedQueries';

export function useCreateSeedQuestionVariantJob() {
  const [createSeedQuestionVariantJobMutation, {loading, error}] = useMutation<
    {createSeedQuestionVariantJob: Job},
    {
      moduleId: string;
      seedQuestionCount: number;
      variantsPerSeed?: number;
      runLimit?: number;
    }
  >(CREATE_SEED_QUESTION_VARIANT_JOB);

  const createSeedQuestionVariantJob = async (
    moduleId: string,
    seedQuestionCount: number,
    variantsPerSeed?: number,
    runLimit?: number,
  ) => {
    const result = await createSeedQuestionVariantJobMutation({
      variables: {moduleId, seedQuestionCount, variantsPerSeed, runLimit},
    });

    return extractGqlData(result).createSeedQuestionVariantJob;
  };

  return {
    createSeedQuestionVariantJob,
    loading,
    error,
  };
}
